module.exports = __webpack_public_path__ + "static/media/g-pay.9d2a8a9d.svg";